import Modal from '@scripts/modules/Modal.js';
import messageModal from '@scripts/modules/MessageModal.js';
import formValidator from '@scripts/modules/FormValidator.js';
import config from '@scripts/modules/config';
import postData from '@scripts/modules/postData.js';

class FreecallForm extends Modal{

  constructor() {
      super();
      this.modal = document.getElementById("freecall-form");
      this.form = document.querySelector('#freecall-form form');
      this.messageItem = this.modal.querySelector('.form__error');
      this.sendButton = document.getElementById("send-freecall");
      this.nameEl = document.getElementById('fc-name');
      this.prepare();
  }

  prepare() {
    super.prepareModal(this.modal);
    this.prepareVerifiedFields();
    this.prepareTriggers();

    // устанавливает обработчик на кнопку отправки
    this.sendButton.addEventListener('click', (e) => {
      e.preventDefault();	  
      this.hideMessage();
      this.unmarkFields();
      if (!this.checkFields()) return;
      this.sendData();
    });

    // логирование вставки в элемент данных из буфера обмена
    this.nameEl.addEventListener('paste', (e) => {
      this.logClipboardWasUsed()
    });

  }

  prepareVerifiedFields() {  
    
    this.verifiedFields = [
      {
        id: 'fc-name',
        type: 'text',
        rule: formValidator.VR_FIELD_REQUIRED,
        message: 'Вы не указали ваше имя'
      },
      {
        id: 'fc-phone',
        type: 'phone',
        rule: formValidator.VR_VALIDATE_PHONE,
        message: 'Неверно указан номер телефона'
      } 
    ]

    for (let i = 0; i < this.verifiedFields.length; i++) {
      const field = this.verifiedFields[i];
      const node = document.getElementById(field.id);
      if (!node) {
        console.log(`Field #${field.id} not found`);
        continue;
      }
      field.node = node;
    }

  }

  prepareTriggers() {
    const triggers = document.querySelectorAll('[data-modal="modal"][data-target="#freecall-form"]');    
    triggers.forEach((trigger) => {
      super.prepareTrigger(trigger)

      // Фиксируем факт открытия формы заказа обратного звонка
      trigger.addEventListener('click', (e) => {
        // console.log('open modal event');
        e.preventDefault();
        this.logModalWasOpenedEvent();
      });


    })
  }

  // open modal
  openModal(modal) {
    this.hideMessage();
    this.enableSendButton();
    this.unmarkFields();
    super.openModal(modal);
  }

  // логирование факта открытия формы заказа обратного звонка
  logModalWasOpenedEvent() {
    const formData = new FormData();
    formData.append('task', 'ui')
    formData.append('uType', 1)

    postData({
      url: config.apiUrl,
      data: formData,

      success: (data) => {

        // Результат не важен
        // if (data.result) {
        //   console.log(data);
        // } else {
        //   console.log('что-то не так', data);
        // }
      },

      error: (data) => {
        // console.log('error', data);
      }
    
    });
  }

  // логирование факта вставки данных через буфер обмена
  logClipboardWasUsed() {
    const formData = new FormData();
    formData.append('task', 'ui')
    formData.append('uType', 3)

    postData({
      url: config.apiUrl,
      data: formData,

      success: (data) => {

        // Результат не важен
        // if (data.result) {
        //   console.log(data);
        // } else {
        //   console.log('что-то не так', data);
        // }
      },

      error: (data) => {
        // console.log('error', data);
      }
    
    });
  }
  
  // отправка данных формы
  sendData() {
    this.unmarkFields();
    this.hideMessage();
    this.disableSendButton();

    postData({
      url: config.apiUrl,
      data: new FormData(this.form),

      success: (data) => {
        
        // console.log(data, data.result);

        if (data.result) {
          this.closeModal(this.modal);
          messageModal.showMessage('Спасибо за заявку, мы обязательно свяжемся с вами в ближайшее время.');

        } else {
          this.showMessage('Произошла ошибка при отправке данных');
          this.enableSendButton();    
        }
      },

      error: (data) => {
        this.showMessage('Произошла ошибка при отправке данных');
        this.enableSendButton();        
        // console.log(config.apiUrl);              
      }
    
    });
  }

  // показывает сообщение об ошибке
  showMessage(messageText) {
    this.messageItem.classList.add('form__error--visible');
    this.messageItem.textContent = messageText;
  }

  // возвращает элемент с сообщением об ошибке в изначальное состояние
  hideMessage() {
    this.messageItem.classList.remove('form__error--visible');
    this.messageItem.textContent = '';
  }

  disableSendButton() {
    this.sendButton.classList.add('modal-button--loading');        
    this.sendButton.setAttribute("disabled", "");
  }

  enableSendButton() {
    this.sendButton.classList.remove('modal-button--loading');    
    this.sendButton.removeAttribute("disabled");
  }

  checkFields() {
    
    for (let i = 0; i < this.verifiedFields.length; i++) {
      const field = this.verifiedFields[i];
      if (!formValidator.checkField(field)) {
        this.showMessage(field.message); 
        this.markField(field.node);
        return false;
      }
    }

    return true;
  }


  markField(field) {
    field.classList.add('field-text--error');
  }

  unmarkFields() {
    for (let i = 0; i < this.verifiedFields.length; i++) 
      this.unmarkField(this.verifiedFields[i].node);
  }


  unmarkField(field) {
    field.classList.remove('field-text--error');
  }

}

export default FreecallForm;